import Career from './Career'

export default class Squad {
  constructor (dataSquad) {
    this.id = dataSquad.id
    this.personId = dataSquad.personId
    this.teamId = dataSquad.teamId
    this.started = dataSquad.started
    this.substitute = dataSquad.substitute

    this.nickname = null
    if (dataSquad.person) {
      this.nickname = dataSquad.person.nicknameFr
    }

    this.shirt = null
    this.positionId = null
    if (dataSquad.career) {
      this.shirt = dataSquad.career.shirt
      this.positionId = dataSquad.career.positionId
    }

    this.career = dataSquad.career ? new Career(dataSquad.career) : null
  }
}
